import React from 'react';
import { AppPage, MimaButton, PageLoader, Searchbar } from '../../components';
import { AnimatePresence } from 'framer-motion';
import MimaOptionMenu from '../../components/OptionMenu';
import styles from '../../assets/styles/BusinessCategory/BusinessCategory.module.scss';
import { useState } from 'react';
import { AddFaqContainer, EditFaqContainer, DeleteFaqContainer } from '../../containers';

const Faqs = ({
    deleteFaqModal,
    goToDeleteFaqModal,
    loading,
    goToAddFaqModal,
    addFaqModal,
    closeModal,
    goToEditFaqModal,
    editFaqModal,
    faqs,
}) => {

    const [filteredFaqs, setFilteredFaqs] = useState([]);
    const [data, setData] = useState({});
    const [items, setItems] = useState({})

    const filterDeletedFaqCategories = faqs.filter(x => x.status.toString() === "true")

    const faqList = faqs.flatMap(x => {
        return x.faqs
    })
    const faqCategories = filterDeletedFaqCategories.map(x => {
        return {
            key: x._id,
            value: x.name,
        }
    })
    return (
        <AppPage pageTitle="All FAQs">
            {loading ? (
                <PageLoader title="while we load your information" />
            ) : (
                <div>
                    <div className={styles.searchMidle}>
                        <Searchbar
                            variant="regular"
                            placeholder="Search"
                            height={5}
                            input={faqList}
                            output={setFilteredFaqs}
                            handleFilter={(item, searchQuery) => {
                                return item?.question.toLowerCase()?.includes(searchQuery) ||
                                    item?.answer.toLowerCase()?.includes(searchQuery)
                            }}
                        />
                        <MimaButton
                            title="Add Questions"
                            width={38}
                            onClick={() => {
                                setData(faqCategories);
                                goToAddFaqModal();
                            }}

                        />
                    </div>

                    <div className='whiteTable'>

                        <table>
                            <thead>
                                <tr>
                                    <th>Questions</th>
                                    <th>Answers</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredFaqs.map((item, index) => {
                                    return (
                                        <tr key={item._id}>
                                            <td>{item.question}</td>
                                            <td>{item.answer}</td>
                                            <td>
                                                <div className='tableAction__text'>
                                                    <MimaOptionMenu
                                                        options={[
                                                            {
                                                                label: "Edit",
                                                                value: "EDIT"
                                                            },
                                                            {
                                                                label: "Delete",
                                                                value: "DELETE"
                                                            }
                                                        ]}
                                                        onOptionSelected={option => {
                                                            if (option.value === "EDIT") {
                                                                setItems(item)
                                                                setData(faqCategories);
                                                                goToEditFaqModal();
                                                            } else if (option.value === "DELETE") {
                                                                setItems(item)
                                                                setData(faqCategories);
                                                                goToDeleteFaqModal()
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                                }

                            </tbody>
                        </table>
                    </div>
                    {(addFaqModal ||
                        editFaqModal ||
                        deleteFaqModal) && (
                            <di className="modal">
                                <AnimatePresence>
                                    {addFaqModal && (
                                        <AddFaqContainer
                                            closeModal={closeModal}
                                            data={data}
                                        />
                                    )}
                                    {editFaqModal && (
                                        <EditFaqContainer
                                            closeModal={closeModal}
                                            items={items}
                                            data={data}
                                        />
                                    )}
                                    {deleteFaqModal && (
                                        <DeleteFaqContainer
                                            closeModal={closeModal}
                                            items={items}
                                            data={data}
                                        />
                                    )}
                                </AnimatePresence>
                            </di>

                        )}
                </div>
            )}
        </AppPage>
    )
}
export default Faqs;